import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { PAGE_HEADER_VERSION_CONFIG } from '../../layout/page/header/page-header.config';
import { ACCESS_RESTRICTION_MODAL_CONFIG } from '../ui/page/access/access-restriction-modal.config';

ICmsContentService.registerPageMetaPatch(pageMeta => {
    const additionalTab = 'Additional';
    const accessRestrictionsTab = 'Access Restriction';

    pageMeta.fields?.push(
        {
            key: 'typeData.pageBackgroundImage',
            type: NICmsContentField.EFieldType.image,
            title: 'Background Image',
            default: false,
            tab: additionalTab
        },
        // header
        ...PAGE_HEADER_VERSION_CONFIG.map(field => ({
            ...field,
            key: `typeData.${field.key}`,
            tab: additionalTab
        })),
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-meta',
            title: 'Meta'
        },
        <NICmsContentField.IField>{
            key: 'typeData.hide_meta_title_suffix',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide meta title suffix',
            default: false
        },
        ...ACCESS_RESTRICTION_MODAL_CONFIG.map(field => ({
            ...field,
            key: `typeData.${field.key}`,
            tab: accessRestrictionsTab
        }))
    );
});
